<template>
  <div id="app">
    
    <Nav> </Nav>
    <Home> </Home>
    <About> </About>
    <Research> </Research>
    <Team> </Team>
    <Contact> </Contact>
    
  </div>
</template>

<script>

import Nav from './components/Nav'
import Home from './components/Home'
import About from './components/About'
import Research from './components/Research'
import Team from './components/Team'
import Contact from './components/Contact'

export default {
  name: 'App',
  components: {
    Nav,
    Home,
    About,
    Research,
    Team,
    Contact
  }
}
</script>

<style>


:root {

    --primary-color: #c4302b;
    --secondary-color: #c0392b;
    --highlight-color: #ff5252;
    --nav-bg: #343a40;

}

*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  /* background-color: #f8f9fa; */
  /* scroll-behavior:smooth */
}

#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;

}

</style>